import * as React from "react";
import {SyntheticEvent} from "react";
import {observer} from "mobx-react";

import "./topic-switcher.scss";

import {Button, Menu} from "semantic-ui-react";

import {AppState} from "../../../components/app/app-mobx";
import {MapState} from "../../map-state";
import {UiState} from "../../ui-state";

import {TopicConfiguration} from "../../../config/topic-configuration";
import {MapViewerConfiguration} from "../../../config/map-viewer-configuration";
import MediaQuery from "react-responsive";
import {Icon} from "../icon/icon";

export interface TopicSwitcherButtonProps {
    appStore: AppState;
    mapStore: MapState;
    uiStore: UiState;
    topics: TopicConfiguration[];
    mapviewerConfig: MapViewerConfiguration;
    showTopic?: boolean;
}

@observer
export class TopicSwitcherButton extends React.Component<TopicSwitcherButtonProps, any> {
    widgetKey = "topic-switcher-button";
    constructor(props: TopicSwitcherButtonProps) {
        super(props);
        this.handleToggle = this.handleToggle.bind(this);
    }

    handleToggle(event?: SyntheticEvent) {
        const {uiStore} = this.props;
        if (uiStore.topicswitcherVisible) {
            uiStore.setTopicswitcherVisible(false);
        } else {
            uiStore.setTopicswitcherVisible(true);
            if(uiStore.isSmallDevice) {
                uiStore.setSidebarVisible(true);
            }
        }
        if(event) {
            event.preventDefault();
        }
    }

    componentDidMount(): void {
        const {uiStore} = this.props;
        if (uiStore.widgets.has(this.widgetKey)) {
            return;
        }
        uiStore.addWidget(this.widgetKey, this);
    }

    componentWillUnmount(): void {
        const {uiStore} = this.props;
        uiStore.removeWidget(this.widgetKey);
    }

    render() {
        const {subtopic} = this.props.appStore;
        const {mapviewerConfig, showTopic} = this.props;

        if (!subtopic) {
            return null;
        }
        if (showTopic) {
            if(mapviewerConfig.subtopics?.length>1) {
                return <Menu.Item
                    as={Button}
                    onClick={this.handleToggle} className="geo-topic-switcher">
                    <MediaQuery minWidth={mapviewerConfig.breakpoints.md}>
                        <Icon name={"navigate_down"} className={"icon--topic-switcher"} />
                    </MediaQuery>
                    {subtopic?.icon ? <Icon name={subtopic.icon}/> : null}
                    <span
                        className="geo-topic-switcher-label">{subtopic?.label ? subtopic.label : subtopic?.name}</span>
                </Menu.Item>;
            } else {
                return <h1><span>{subtopic?.label ? subtopic.label : subtopic?.name}</span></h1>;
            }
        } else {
            return <div className={"geo-topic-switcher"}><Button
                compact
                size={"mini"}
                onClick={this.handleToggle}>
                <Icon name={"signpost"} className={"icon--topic-switcher"} />
                {mapviewerConfig.topicSwitcher?.button}
            </Button></div>;
        }
    }
}
